<template>
  <p class="value-crud-action--delete">
    <a @click="unassign">
      <i class="icon status-inactive">clear</i>
    </a>
  </p>
</template>
<script>
export default {
  props: ["item", "model", "column"],
  components: {},
  methods: {
    unassign() {
      this.$emit("itemDelete", this.item);
    }
  },
  computed: {
    routeParams() {
      return { name: this.model + "_delete", params: { id: this.item.id } };
    }
  }
};
</script>
<style lang="scss">
.value-crud-action--delete .btn {
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// CollectionValueUnassign.vue?17f658a8